import { Grid, TextField, Typography } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";

import { DynamicFormHandlerProps } from "../..";

import DadosBasicos from "./DadosBasicos";
import DadosConjuge from "./DadosConjuge";
import DadosEndereco from "./DadosEndereco";
import DadosCooperado from "./DadosCooperado";
import DadosSociedade from "./DadosSociedade";
import DadosProcurador from "./DadosProcuradores";
import DadosFazendas from "./DadosFazendas";
import DadosTerceiros from "./DadosTerceiros";

export default function DynDadosCadastrais({ spec, extras }: DynDadosCadastraisProps) {
    const { watch } = useFormContext();

    const possuiConjuge = watch(`${spec.name}.possui_conjuge`) === "Sim"

    return (
        <Grid container spacing={2} mb={2}>
            {/* Dados Básicos */}
            <DadosBasicos {...{ spec, extras }} />

            {/* Dados de Endereço */}
            <DadosEndereco {...{ spec, extras }} />

            {/* Dados do Cooperado */}
            <DadosCooperado {...{ spec, extras }} />

            {/* Possui Sociedade? */}
            <DadosSociedade {...{ spec, extras }} />

            {/* Possui Procurador? */}
            <DadosProcurador {...{ spec, extras }} />

            {/* Possui Terceiros? */}
            <DadosTerceiros {...{ spec, extras }} />

            {/* Dados do Cônjuge/Companheiro(a) */}
            {
                possuiConjuge &&
                <DadosConjuge {...{ spec, extras }} />
            }

            {/* Dados Fazenda(s) */}
            <DadosFazendas {...{ spec, extras }} />



        </Grid >
    )
}

export interface DynDadosCadastraisProps extends DynamicFormHandlerProps {
}

